var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 45,
    viewBox: "0 0 65 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25664 23.7112C12.0944 33.3944 25.4599 31.1065 25.1671 30.4902C16.4545 12.0944 8.71259 5.80839 8.71259 5.80839C16.4545 10.6462 26.6154 27.1007 26.6154 27.1007C31.9385 0 0 0 0 0C5.80839 4.35244 2.41888 14.0357 7.25664 23.7112Z",
    fill: "#0EDB6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8339 15.4916C29.7352 19.066 29.7584 23.0949 28.8802 27.5475L26.9389 32.0232C26.7155 32.3005 26.4074 32.5393 26.0222 32.7319C25.1671 33.1479 23.3337 33.5023 21.0689 33.5023C20.4834 33.5023 19.8671 33.4715 19.2355 33.4252C18.9966 37.9009 19.8055 41.2519 20.1907 41.0747C47.1989 28.2793 56.4354 16.9091 56.4354 16.9091C49.3251 28.2793 25.1671 43.2009 25.1671 43.2009C64.9631 51.0199 64.9631 4.11365 64.9631 4.11365C58.5692 12.6414 44.3564 7.66493 30.1358 14.7752C29.689 14.9986 29.2499 15.2374 28.8339 15.4916Z",
    fill: "#0EDB6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.547db1841cea16fb1c0f6e8c66590c29.svg";
export { ForwardRef as ReactComponent };